(function(){
  var R = window.AN_ROUTES || { cart: '/cart', cartChange: '/cart/change', cartAdd: '/cart/add' };
  var T = window.AN_THEME || {};
  var lastUpsellProductId = null;

  function $(s, r){ return (r || document).querySelector(s); }
  function money(cents){ return '₹' + Math.round((Number(cents) || 0) / 100).toLocaleString('en-IN'); }
  function escapeHtml(v){ return String(v || '').replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[c]; }); }
  function imgSrc(obj){
    if(!obj) return '';
    if(typeof obj === 'string') return obj;
    return obj.url || obj.src || obj.preview_image || '';
  }
  function openDrawer(){
    var d = $('#drawer'), s = $('#scrim');
    if(d) d.classList.add('open');
    if(s) s.classList.add('open');
    document.body.classList.add('an-cart-lock');
  }
  function closeDrawer(){
    var d = $('#drawer'), s = $('#scrim');
    if(d) d.classList.remove('open');
    if(s) s.classList.remove('open');
    document.body.classList.remove('an-cart-lock');
  }

  function setupDrawer(){
    var d = $('#drawer');
    if(!d || d.dataset.anUpgraded === '1') return;
    d.dataset.anUpgraded = '1';
    d.innerHTML = '<div class="an-cart__top">' +
      '<div><div class="an-cart__eyebrow">After Note</div><h3>' + escapeHtml(T.cartHeading || 'Your Fragrance Selection') + '</h3><p>' + escapeHtml(T.cartDescription || 'Review your cart and complete the ritual with curated add-ons.') + '</p></div>' +
      '<button class="an-cart__close" id="cartClose" type="button" aria-label="Close cart"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/></svg></button>' +
      '</div><div class="an-cart__body"><div class="drawer-items an-cart__items" id="drawerItems"></div><div class="an-cart__upsells" id="drawerUpsells"></div></div><div class="drawer-f an-cart__foot" id="drawerFoot"></div>';
  }

  function fetchCart(cb){
    fetch(R.cart + '.js', { headers: { 'Accept':'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){ renderCart(cart); if(cb) cb(cart); })
      .catch(function(){});
  }

  function renderCart(cart){
    setupDrawer();
    var count = $('#cartCount');
    if(count) count.textContent = cart.item_count || 0;
    var items = $('#drawerItems'), foot = $('#drawerFoot');
    if(!items || !foot) return;

    if(!cart.items || !cart.items.length){
      items.innerHTML = '<div class="an-cart__empty"><div>' + escapeHtml(T.cartEmpty || 'Your cart is empty. Discover a fragrance that feels like you.') + '</div></div>';
      foot.innerHTML = '<a class="an-cart__checkout" href="/collections/all">Explore Collection</a>';
      var upEmpty = $('#drawerUpsells');
      if(upEmpty) upEmpty.innerHTML = '';
      return;
    }

    items.innerHTML = cart.items.map(function(it){
      var vendor = it.vendor || '';
      var title = (it.product_title || it.title || '').replace(vendor, '').trim() || it.product_title || it.title || '';
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="an-cart__meta">' + escapeHtml(it.variant_title) + '</div>' : '';
      var image = it.image ? '<img src="' + escapeHtml(it.image) + '" alt="">' : '';
      return '<div class="an-cart__item">' +
        '<div class="an-cart__thumb">' + image + '</div>' +
        '<div class="an-cart__copy"><div class="an-cart__brand">' + escapeHtml(vendor || 'After Note') + '</div><div class="an-cart__name">' + escapeHtml(title) + '</div>' + variant + '<div class="an-cart__meta">' + money(it.final_line_price || it.line_price || it.price) + '</div>' +
        '<div class="an-cart__qty" data-key="' + escapeHtml(it.key) + '"><button type="button" data-an-qty="dec">−</button><span>' + it.quantity + '</span><button type="button" data-an-qty="inc">+</button></div></div>' +
        '<button class="an-cart__remove" type="button" data-an-remove="' + escapeHtml(it.key) + '">Remove</button>' +
      '</div>';
    }).join('');

    foot.innerHTML = '<div class="an-cart__subtotal"><span>Subtotal</span><strong>' + money(cart.total_price || 0) + '</strong></div>' +
      '<div class="an-cart__ship">' + escapeHtml(T.cartShipping || 'Free shipping on all orders') + '</div>' +
      // '<a href="/checkout" class="an-cart__checkout">' + escapeHtml(T.cartCheckout || 'Proceed to Checkout') + '</a>' +
      '<button type="button" id="checkout2" onclick="handleFloCheckoutBtn()" class="an-cart__checkout" name="checkout2" style="cursor: pointer;">' + escapeHtml(T.cartCheckout || 'Proceed to Checkout') + '</button>'
      '<button class="an-cart__continue" type="button" data-an-continue>' + escapeHtml(T.cartContinue || 'Continue shopping') + '</button>';

    renderUpsells(cart);
  }

  function changeLine(key, qty){
    fetch(R.cartChange + '.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ id:key, quantity:qty }) })
      .then(function(r){ return r.json(); })
      .then(renderCart)
      .catch(function(){});
  }

  function productPrice(p){
    if(typeof p.price === 'number') return money(p.price);
    if(p.price && !isNaN(Number(p.price))) return money(Number(p.price));
    if(p.variants && p.variants[0] && p.variants[0].price){
      var val = Number(String(p.variants[0].price).replace(/[^0-9.]/g,''));
      return val > 999 ? '₹' + Math.round(val).toLocaleString('en-IN') : money(val * 100);
    }
    return '';
  }

  function variantId(p){
    var v = null;
    if(p.variants && p.variants.length){
      v = p.variants.find(function(x){ return x.available !== false; }) || p.variants[0];
    }
    return v && v.id;
  }

  function renderUpsells(cart){
    if(T.cartRecommendations === false){ var hidden = $('#drawerUpsells'); if(hidden) hidden.innerHTML = ''; return; }
    var box = $('#drawerUpsells');
    if(!box) return;
    var base = cart.items && cart.items[0] && cart.items[0].product_id;
    if(!base){ box.innerHTML = ''; return; }
    lastUpsellProductId = base;
    box.innerHTML = '<div class="an-upsell__head"><h4>Complete the ritual</h4><span>Curated add-ons</span></div>';
    fetch('/recommendations/products.json?product_id=' + encodeURIComponent(base) + '&limit=4&intent=related', { headers:{'Accept':'application/json'} })
      .then(function(r){ return r.json(); })
      .then(function(data){
        if(base !== lastUpsellProductId) return;
        var products = (data && data.products) || [];
        var inCart = {};
        (cart.items || []).forEach(function(it){ inCart[it.product_id] = true; });
        products = products.filter(function(p){ return !inCart[p.id] && variantId(p); }).slice(0,3);
        if(!products.length){ box.innerHTML = ''; return; }
        box.innerHTML = '<div class="an-upsell__head"><h4>Complete the ritual</h4><span>Curated add-ons</span></div><div class="an-upsell__grid">' + products.map(function(p){
          var image = imgSrc(p.featured_image || p.image);
          return '<div class="an-upsell"><div class="an-upsell__img">' + (image ? '<img src="' + escapeHtml(image) + '" alt="">' : '') + '</div>' +
            '<div><div class="an-upsell__brand">' + escapeHtml(p.vendor || '') + '</div><div class="an-upsell__name">' + escapeHtml(p.title || '') + '</div><div class="an-upsell__price">' + escapeHtml(productPrice(p)) + '</div></div>' +
            '<button class="an-upsell__add" type="button" data-an-upsell-add="' + escapeHtml(variantId(p)) + '">Add</button></div>';
        }).join('') + '</div>';
      })
      .catch(function(){ box.innerHTML = ''; });
  }

  function isAddForm(form){
    if(!form) return false;
    var action = String(form.getAttribute('action') || '');
    return form.classList.contains('js-add') || action.indexOf('/cart/add') !== -1;
  }

  function addForm(form, submitter){
    var btn = submitter || form.querySelector('button[type="submit"], input[type="submit"]');
    var old = btn ? (btn.tagName === 'INPUT' ? btn.value : btn.textContent) : '';
    if(btn){ btn.disabled = true; if(btn.tagName === 'INPUT') btn.value = 'Adding...'; else btn.textContent = 'Adding...'; }
    var data;
    try { data = new FormData(form, submitter); } catch(e) { data = new FormData(form); }
    fetch(R.cartAdd + '.js', { method:'POST', headers:{'Accept':'application/json'}, body:data })
      .then(function(r){ if(!r.ok) throw new Error('Cart add failed'); return r.json(); })
      .then(function(){ fetchCart(function(){ openDrawer(); }); })
      .catch(function(){ window.location.href = R.cart; })
      .finally(function(){ if(btn){ btn.disabled = false; if(btn.tagName === 'INPUT') btn.value = old; else btn.textContent = old; } });
  }

  function addVariant(id){
    if(!id) return;
    fetch(R.cartAdd + '.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ items:[{ id:Number(id), quantity:1 }] }) })
      .then(function(r){ return r.json(); })
      .then(function(){ fetchCart(function(){ openDrawer(); }); })
      .catch(function(){});
  }

  function bind(){
    setupDrawer();
    document.addEventListener('submit', function(e){
      var form = e.target && e.target.closest && e.target.closest('form');
      if(!isAddForm(form)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      addForm(form, e.submitter);
    }, true);

    document.addEventListener('click', function(e){
      var close = e.target.closest('#cartClose, [data-an-continue]');
      if(close){ e.preventDefault(); closeDrawer(); return; }
      var scrim = e.target.closest('#scrim');
      if(scrim){ e.preventDefault(); closeDrawer(); return; }
      var toggle = e.target.closest('#cartToggle, a[href="/cart"], a[href$="/cart"]');
      if(toggle && !e.target.closest('.drawer')){ if(T.cartDrawer === false) return; e.preventDefault(); e.stopImmediatePropagation(); fetchCart(function(){ openDrawer(); }); return; }
      var q = e.target.closest('[data-an-qty]');
      if(q){
        e.preventDefault();
        var wrap = q.closest('.an-cart__qty');
        var key = wrap && wrap.getAttribute('data-key');
        var cur = parseInt(wrap.querySelector('span').textContent,10) || 1;
        changeLine(key, q.getAttribute('data-an-qty') === 'inc' ? cur + 1 : cur - 1);
        return;
      }
      var rm = e.target.closest('[data-an-remove]');
      if(rm){ e.preventDefault(); changeLine(rm.getAttribute('data-an-remove'), 0); return; }
      var up = e.target.closest('[data-an-upsell-add]');
      if(up){ e.preventDefault(); addVariant(up.getAttribute('data-an-upsell-add')); }
    }, true);

    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeDrawer(); });
    fetchCart();
    setTimeout(fetchCart, 350);
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
})();

(function(){
  function linkFooterMark(){
    var mark = document.querySelector('footer .fmark');
    if(!mark || mark.tagName.toLowerCase() === 'a') return;
    var link = document.createElement('a');
    link.href = '/';
    link.className = mark.className;
    link.setAttribute('aria-label', 'After Note home');
    link.style.display = 'block';
    link.style.color = 'inherit';
    link.style.textDecoration = 'none';
    while(mark.firstChild) link.appendChild(mark.firstChild);
    mark.parentNode.replaceChild(link, mark);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', linkFooterMark); else linkFooterMark();
})();
